import React, { useEffect, useRef, useState } from "react";
import { Lock, Mail, Smartphone, User } from "lucide-react";
import CustomModalLayout from "../../../web/Auth/CustomModalLayout";
import { Button } from "../../../../shadcn/components/ui/button";
import Router from "next/router";
import { useDispatch, useSelector } from "react-redux";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from "../../../../shadcn/components/ui/input-otp";
import { loginOtp, sendOtpEmail, sendOtpMobile } from "services/bidder";
import { clearAuth, clearBidderAuth, clearGuestUser } from "store";
import Loader from "app/layouts/Loader";
import { DateTime } from "luxon";

export default function BidderTwoFactorAuth(props: any) {
  const dispatch = useDispatch();
  const [otp, setOtp] = useState("");
  const [isValidating, setIsValidating] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [errorMessage, setResendError] = useState("");
  const [is2FALoading, setIs2FALoading] = useState(true);
  // const bc = new BroadcastChannel("2fa-tabs");

  const user = useSelector((state: any) => state.bidderAuth.user);
  const getISTDate = () => {
    return DateTime.now().setZone("Asia/Kolkata").toFormat("yyyy-MM-dd");
  };

  const is2FAVerifiedForToday = (verified2faDate: any) => {
    return verified2faDate === getISTDate();
  };

  const set2FAVerified = async () => {
    localStorage.setItem("2faVerifiedDate", getISTDate());
    const res = await fetch("/api/2fa", { method: "POST" });
    // console.log("res: ", res);
    setIsAuthenticated(true);
    setOtp("");
  };

  const email = user?.attributes?.find((a: any) => a.type === "email")?.value;
  const mobile = user?.attributes?.find(
    (a: any) => a.type === "mobile_number"
  )?.value;

  const hasEmail = Boolean(email);
  const hasMobile = Boolean(mobile);

  const [verifyVia, setVerifyVia] = useState<"email" | "sms">(
    hasEmail ? "email" : "sms"
  );

  const maskEmail = (email: string) => {
    if (!email) return "";
    const parts = email.split("@");
    const local = parts[0];
    const domain = parts[1] || "";
    return local.slice(0, 1) + `*****${local.slice(-1)}@` + domain;
  };
  const maskMobile = (number: string) => {
    return `${number.slice(0, 3)}*******${number.slice(-1)}`;
  };
  const handleResendOtp = async () => {
    if (countdown > 0) return;
    try {
      if (verifyVia === "email" && hasEmail) {
        await sendOtpEmail({ value: email });
      } else if (verifyVia === "sms" && hasMobile) {
        await sendOtpMobile({ value: mobile });
      }
      setCountdown(30);
      setResendError("");
    } catch (error) {
      console.error("Failed to resend OTP:", error);
      setResendError("Failed to send OTP. Please try again.");
    }
  };

  const logoutAndRedirect = async () => {
    await fetch("/api/logout", { method: "GET" });
    Router.replace("/login");
    dispatch(clearBidderAuth());
    dispatch(clearAuth());
    dispatch(clearGuestUser());
    setIsAuthenticated(false);
    localStorage.removeItem("2faVerifiedDate");
    localStorage.removeItem("tabIds");
    sessionStorage.removeItem("tabId");
    sessionStorage.removeItem("refreshing");
    sessionStorage.removeItem("activeTabId");
    setOtp("");

    // Optional: close BroadcastChannel
    // if (typeof bc !== "undefined") bc.close?.();
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setResendError("");
    if (otp.length < 6) return;
    setIsValidating(true);
    const payload = {
      otp,
      type: verifyVia === "email" ? "email" : "mobile_number",
      value: verifyVia === "email" ? email : mobile,
    };
    try {
      await loginOtp(payload);
      set2FAVerified();
    } catch (error) {
      console.error("OTP verification failed:", error);
      setResendError("Incorrect OTP. Please try again.");
    } finally {
      setIsValidating(false);
    }
  };
  // const pendingEventRef = useRef<BeforeUnloadEvent | null>(null);

  useEffect(() => {
    // 🧠 STEP 1: Persisted tabId in localStorage
    // let uniqueId = localStorage.getItem("activeTabId");
    // if (!uniqueId) {
    //   uniqueId = `tab-${Date.now()}-${Math.random()}`;
    //   localStorage.setItem("activeTabId", uniqueId);
    // }
    // const incrementTabCount = () => {
    //   const raw = localStorage.getItem("tabIds");
    //   const currentTabs = raw ? JSON.parse(raw) : [];
    //   if (!currentTabs.includes(uniqueId)) {
    //     currentTabs.push(uniqueId);
    //     localStorage.setItem("tabIds", JSON.stringify(currentTabs));
    //   }
    // };
    // const decrementTabCount = () => {
    //   const isRefreshing = localStorage.getItem("refreshing") === "true";
    //   localStorage.setItem("refreshing", "false");
    //   if (isRefreshing) {
    //     return; // Skip decrement on refresh
    //   }
    //   const raw = localStorage.getItem("tabIds");
    //   const currentTabs = raw ? JSON.parse(raw) : [];
    //   const updatedTabs = currentTabs.filter((id: string) => id !== uniqueId);
    //   localStorage.setItem("tabIds", JSON.stringify(updatedTabs));
    //   if (updatedTabs.length === 0) {
    //     localStorage.removeItem("2faVerifiedDate");
    //   }
    // };
    // const handleBeforeUnload = () => {
    //   localStorage.setItem("refreshing", "true");
    // };
    // incrementTabCount();
    // window.addEventListener("beforeunload", handleBeforeUnload);
    // window.addEventListener("pagehide", decrementTabCount);
    // window.addEventListener("unload", decrementTabCount);
    // 2FA sync
    // bc.onmessage = (event) => {
    //   if (event.data === "2fa-verified") {
    //     localStorage.setItem("2faVerifiedDate", getISTDate());
    //     setIsAuthenticated(true);
    //   }
    // };
    //new
    // const tabIdsKey = "tabIds";
    // const raw = localStorage.getItem(tabIdsKey);
    // const currentTabs = raw ? JSON.parse(raw) : [];
    // const currentTabCount = currentTabs.length;
    // const uniqueTabId = `tab-${Date.now()}-${currentTabCount + 1}`;
    // const refreshingKey = "isRefreshing";
    // const refreshingTabKey = "refreshingTabId";
    // const getTabIds = (): string[] => {
    //   const raw = localStorage.getItem(tabIdsKey);
    //   return raw ? JSON.parse(raw) : [];
    // };
    // const setTabIds = (ids: string[]) => {
    //   localStorage.setItem(tabIdsKey, JSON.stringify(ids));
    // };
    // const incrementTabCount = () => {
    //   console.log("call----3");
    //   const tabs = getTabIds();
    //   if (!tabs.includes(uniqueTabId)) {
    //     tabs.push(uniqueTabId);
    //     setTabIds(tabs);
    //   }
    // };
    // const decrementTabCount = () => {
    //   console.log("call----2");
    //   const isRefreshing = localStorage.getItem(refreshingKey) === "true";
    //   localStorage.setItem(refreshingKey, "false");
    //   if (isRefreshing) return;
    //   const tabs = getTabIds().filter((id) => id !== uniqueTabId);
    //   setTabIds(tabs);
    // };
    // const handleBeforeUnload = () => {
    //   console.log("call----1");
    //   localStorage.setItem(refreshingKey, "true");
    //   const tabs = getTabIds();
    //   if (tabs?.length === 1) {
    //     localStorage.setItem(
    //       refreshingTabKey,
    //       `tab-${Date.now()}-${tabs?.length}}`
    //     );
    //   }
    // };
    // const lastRefreshedTab = localStorage.getItem(refreshingTabKey);
    // if (lastRefreshedTab) {
    //   const match: any = lastRefreshedTab.match(/tab-(\d+)-/);
    //   const timestamp = Number(match[1]);
    //   const secondsAgo = Math.floor((Date.now() - timestamp) / 1000);
    //   console.log("✅ This tab was refreshed:", uniqueTabId, lastRefreshedTab);
    //   console.log(`⏱️ It happened ${secondsAgo} seconds ago.`);
    //   localStorage.removeItem(lastRefreshedTab);
    // } else {
    //   console.log("🆕 This is a new tab:", uniqueTabId, lastRefreshedTab);
    // }
    // // Reset refresh state
    // localStorage.setItem(refreshingKey, "false");
    // localStorage.removeItem(refreshingTabKey);
    // // Mount logic
    // incrementTabCount();
    // window.addEventListener("beforeunload", handleBeforeUnload);
    // window.addEventListener("pagehide", decrementTabCount);
    // window.addEventListener("unload", decrementTabCount);
    //new 2
    // const tabIdsKey = "tabIds";
    // const refreshingKey = "isRefreshing";
    // const refreshingTabKey = "refreshingTabId";
    // const getTabIds = (): string[] => {
    //   const raw = localStorage.getItem(tabIdsKey);
    //   return raw ? JSON.parse(raw) : [];
    // };
    // const setTabIds = (ids: string[]) => {
    //   localStorage.setItem(tabIdsKey, JSON.stringify(ids));
    // };
    // // Assign tab ID based on time + tab count
    // const currentTabs = getTabIds();
    // const currentTabCount = currentTabs.length;
    // const uniqueTabId = `tab-${Date.now()}-${currentTabCount + 1}`;
    // sessionStorage.setItem("tabId", uniqueTabId); // optional for reference
    // const incrementTabCount = () => {
    //   const tabs = getTabIds();
    //   if (!tabs.includes(uniqueTabId)) {
    //     tabs.push(uniqueTabId);
    //     setTabIds(tabs);
    //   }
    // };
    // const decrementTabCount = (e: any) => {
    //   console.log("e:-------->>> ", e);
    //   sessionStorage.setItem("dec", JSON.stringify(e));
    //   const isRefreshing = localStorage.getItem(refreshingKey) === "true";
    //   localStorage.setItem(refreshingKey, "false");
    //   if (isRefreshing) return; // don't remove if it's a refresh
    //   const tabs = getTabIds().filter((id) => id !== uniqueTabId);
    //   setTabIds(tabs);
    // };
    // const handleBeforeUnload = (e: BeforeUnloadEvent) => {
    //   window.alert("helloo");
    //   e.preventDefault();
    //   e.returnValue = ""; // Show default browser dialog
    //   // Store pending event & show custom modal
    //   pendingEventRef.current = e;
    //   setIsOpen(true);
    //   return "";
    //   const tabs = getTabIds();
    //   if (tabs.length === 1) {
    //     localStorage.setItem(refreshingTabKey, uniqueTabId);
    //   }
    //   localStorage.setItem(refreshingKey, "true");
    //   // Block default action
    //   return "";
    // };
    // // const handleBeforeUnload = (e: any) => {
    // //   e.preventDefault();
    // //   e.returnValue = ""; // Show default browser dialog
    // //   // Store pending event & show custom modal
    // //   pendingEventRef.current = e;
    // //   setIsOpen(true);
    // //   localStorage.setItem(refreshingKey, "true");
    // //   const tabs = getTabIds();
    // //   if (tabs.length === 1) {
    // //     // Only save refreshingTabKey if it's the last open tab
    // //     localStorage.setItem(refreshingTabKey, uniqueTabId);
    // //   }
    // // };
    // // Handle if last tab was refreshed
    // const lastRefreshedTab = localStorage.getItem(refreshingTabKey);
    // if (lastRefreshedTab) {
    //   const match = lastRefreshedTab.match(/tab-(\d+)-/);
    //   if (match) {
    //     const timestamp = Number(match[1]);
    //     const secondsAgo = Math.floor((Date.now() - timestamp) / 1000);
    //     console.log("✅ Last tab was refreshed:", lastRefreshedTab);
    //     console.log(`⏱️ It was refreshed ${secondsAgo} seconds ago.`);
    //   }
    //   localStorage.removeItem(refreshingTabKey);
    // } else {
    //   console.log("🆕 This is a new tab:", uniqueTabId);
    // }
    // const pageHideFn = (e: any) => {
    //   console.log("e=======>>>", e);
    //   sessionStorage.setItem("pageHide", "called234567890");
    // };
    // // Init state
    // localStorage.setItem(refreshingKey, "false");
    // incrementTabCount();
    // Cleanup listeners
    // window.addEventListener("onbeforeunload", function (e) {
    //   e.preventDefault();
    //   return "Data will be lost if you leave the page, are you sure?";
    // });
    // window.addEventListener("pagehide", pageHideFn);
    // window.addEventListener("unload", decrementTabCount);
    const checkVerification = async () => {
      const res = await fetch("/api/2fa", { method: "GET" });
      if (!res.ok) {
        console.error("Error fetching 2FA data:", res.status);
      } else {
        const data = await res.json();
        console.log("2FA Data:", data);
        const verified = is2FAVerifiedForToday(data.date);
        console.log("verified: ", verified);
        // const tabIds = JSON.parse(localStorage.getItem("tabIds") || "[]");
        if (verified) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
          if (hasEmail) await sendOtpEmail({ value: email });
          if (hasMobile) await sendOtpMobile({ value: mobile });
        }
        setIs2FALoading(false);
      }
    };
    checkVerification();
    // return () => {
    //   // decrementTabCount();
    //   window.removeEventListener("beforeunload", handleBeforeUnload);
    //   window.removeEventListener("pagehide", decrementTabCount);
    //   window.removeEventListener("unload", decrementTabCount);
    // };
    //old
    // return () => {
    //   decrementTabCount();
    //   bc.close();
    //   window.removeEventListener("beforeunload", handleBeforeUnload);
    //   window.removeEventListener("pagehide", decrementTabCount);
    //   window.removeEventListener("unload", decrementTabCount);
    // };
    // return () => {
    //   window.removeEventListener("onbeforeunload", function (e) {
    //     e.preventDefault();
    //     return "Data will be lost if you leave the page, are you sure?";
    //   });
    // };
  }, [email, mobile]);
  // useEffect(() => {
  //   const uniqueTabId = `tab-${Date.now()}-${Math.random()}`;
  //   const tabIdsKey = "tabIds";
  //   const refreshingKey = "isRefreshing";
  //   const refreshingTabKey = "refreshingTabId";

  //   const getTabIds = (): string[] => {
  //     const raw = localStorage.getItem(tabIdsKey);
  //     return raw ? JSON.parse(raw) : [];
  //   };

  //   const setTabIds = (ids: string[]) => {
  //     localStorage.setItem(tabIdsKey, JSON.stringify(ids));
  //   };

  //   const incrementTabCount = () => {
  //     const tabs = getTabIds();
  //     if (!tabs.includes(uniqueTabId)) {
  //       tabs.push(uniqueTabId);
  //       setTabIds(tabs);
  //     }
  //   };

  //   const decrementTabCount = () => {
  //     const isRefreshing = localStorage.getItem(refreshingKey) === "true";
  //     localStorage.setItem(refreshingKey, "false");
  //     if (isRefreshing) return;
  //     const tabs = getTabIds().filter((id) => id !== uniqueTabId);
  //     setTabIds(tabs);
  //   };

  //   const handleBeforeUnload = () => {
  //     console.log("called---");
  //     localStorage.setItem(refreshingKey, "true");
  //     localStorage.setItem(refreshingTabKey, uniqueTabId); // store ID being refreshed
  //   };

  //   // ✅ Detect which tab was refreshed
  //   const wasRefreshing = localStorage.getItem(refreshingKey) === "true";
  //   const lastRefreshedTab = localStorage.getItem(refreshingTabKey);

  //   if (wasRefreshing && lastRefreshedTab === uniqueTabId) {
  //     console.log("✅ This tab was refreshed:", uniqueTabId, lastRefreshedTab);
  //   } else if (wasRefreshing && lastRefreshedTab) {
  //     console.log(
  //       "❗Another tab was refreshed:",
  //       lastRefreshedTab,
  //       lastRefreshedTab
  //     );
  //   } else {
  //     console.log("🆕 This is a new tab:", uniqueTabId, lastRefreshedTab);
  //   }

  //   // Reset refresh state
  //   localStorage.setItem(refreshingKey, "false");
  //   localStorage.removeItem(refreshingTabKey);

  //   // Mount logic
  //   incrementTabCount();
  //   window.addEventListener("beforeunload", handleBeforeUnload);
  //   window.addEventListener("pagehide", decrementTabCount);
  //   window.addEventListener("unload", decrementTabCount);

  //   return () => {
  //     decrementTabCount();
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //     window.removeEventListener("pagehide", decrementTabCount);
  //     window.removeEventListener("unload", decrementTabCount);
  //   };
  // }, []);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [countdown]);

  if (is2FALoading) {
    return (
      <div className="w-screen h-screen flex items-center justify-center">
        <Loader height="h-16" width="w-16" color="text-brand-orange" />
      </div>
    );
  }

  if (isAuthenticated || !user) return <>{props?.children}</>;

  return (
    <CustomModalLayout
      open={true}
      showCross={false}
      childrenClassName="px-4 lg:px-16 py-3 lg:py-6 bg-brand-bgGrey"
      className="bg-brand-bgGrey pt-0 w-full mx-4 max-w-[550px] rounded-2xl overflow-y-scroll max-h-[calc(100%-10px)]"
    >
      <div className="flex flex-col font-openSans">
        <div className="text-center">
          <div className="inline-block p-3 rounded-full bg-[#efdacf]">
            <Lock className="w-7 h-7 text-brand-orange" />
          </div>
          <h2 className="mt-2 text-xl font-semibold text-brand-textBlack font-openSans">
            Two-Factor Authentication
          </h2>
          <p className="text-xs text-gray-700">
            Verify your identity to continue.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          {/* Method info */}
          {hasEmail && hasMobile && (
            <>
              <p className="text-sm text-gray-700 text-center">
                OTP sent to {maskEmail(email)} and {maskMobile(mobile)}.
              </p>
              <div className="flex justify-center gap-6 mt-3">
                <label className="flex items-center gap-2 text-gray-700 cursor-pointer text-sm">
                  <input
                    type="radio"
                    name="verifyVia"
                    value="email"
                    checked={verifyVia === "email"}
                    onChange={() => setVerifyVia("email")}
                  />
                  <Mail className="w-4 h-4 text-brand-orange" /> Email
                </label>
                <label className="flex items-center gap-2 text-gray-700 cursor-pointer text-sm">
                  <input
                    type="radio"
                    name="verifyVia"
                    value="sms"
                    checked={verifyVia === "sms"}
                    onChange={() => setVerifyVia("sms")}
                  />
                  <Smartphone className="w-4 h-4 text-brand-orange" /> Mobile
                </label>
              </div>
            </>
          )}

          {!hasEmail && hasMobile && (
            <p className="text-center text-sm text-gray-700">
              OTP sent to your mobile: {maskMobile(mobile)}
            </p>
          )}
          {!hasMobile && hasEmail && (
            <p className="text-center text-sm text-gray-700">
              OTP sent to your email: {maskEmail(email)}
            </p>
          )}

          {/* OTP input */}
          <div className="flex flex-col items-center mx-auto">
            <label className="mb-2 px-2 text-xs self-center font-medium text-gray-700">
              Enter OTP ({verifyVia === "email" ? "Email" : "SMS"})
            </label>
            <InputOTP
              value={otp}
              onChange={(val: string) => setOtp(val.replace(/\D/g, ""))}
              maxLength={6}
            >
              <InputOTPGroup className="flex justify-center gap-x-3">
                {Array.from({ length: 6 }).map((_, i) => (
                  <InputOTPSlot
                    key={i}
                    index={i}
                    className="bg-white border-none rounded-none h-[58px] w-9 mobile:w-10 sm:w-12"
                  />
                ))}
              </InputOTPGroup>
            </InputOTP>
          </div>

          {/* Submit + resend */}
          <div>
            <div className="text-xs text-right mb-2">
              {countdown > 0 ? (
                <p className="text-gray-500">Resend OTP in {countdown}s</p>
              ) : (
                <button
                  type="button"
                  onClick={handleResendOtp}
                  className="text-blue-600 hover:underline"
                >
                  Resend {verifyVia === "email" ? "Email" : "SMS"} OTP
                </button>
              )}
            </div>
            <Button
              type="submit"
              className="w-full h-9 sm:h-10"
              disabled={isValidating || otp.length < 6}
            >
              {isValidating ? "Verifying..." : "Verify OTP"}
            </Button>
            {errorMessage && (
              <p className="text-red-600 text-xs text-center">{errorMessage}</p>
            )}
          </div>

          <div className="flex justify-center">
            <button
              type="button"
              onClick={logoutAndRedirect}
              className="flex items-center gap-2 text-xs text-blue-600 hover:underline cursor-pointer"
            >
              <User className="w-4 h-4 text-brand-orange" />
              Switch to a different account
            </button>
          </div>
        </form>
      </div>
    </CustomModalLayout>
  );
}
